/**
 * @GENERATED from Figma node 3608:51046
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GetGuruDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#03D6A1"
      d="m16.303 20.292-4.699 1.338c-3.516.996-7.126-1.12-8.09-4.792l-1.276-4.855c-.965-3.64 1.089-7.406 4.605-8.401l4.7-1.338c3.516-.996 7.125 1.151 8.09 4.792l1.276 4.854c.964 3.641-1.09 7.406-4.606 8.402"
    />
    <path
      fill="#fff"
      d="M10.609 16.153a4.1 4.1 0 0 0 2.365-.155c.964-.374 1.867-1.183 2.116-2.116.373-.187.716-.436 1.058-.685.03 1.712-1.4 3.205-2.894 3.765a4.8 4.8 0 0 1-1.743.343c-.404 0-.809-.062-1.182-.156a5.4 5.4 0 0 1-2.21-1.276c-2.178-2.053-2.271-5.508-.186-7.686a4.93 4.93 0 0 1 3.578-1.556c2.396.031 3.859 1.836 3.921 1.93a.5.5 0 0 1-.062.715h-.031a.46.46 0 0 1-.654-.093s-1.245-1.525-3.174-1.556h-.03a4.1 4.1 0 0 0-2.833 1.245 4.2 4.2 0 0 0-1.213 3.08 4.435 4.435 0 0 0 3.174 4.201"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M15.556 11.672c.374-.28.747-.59 1.058-.933.218-.187.498-.218.654-.031a.527.527 0 0 1 .03.715c-.373.405-.808.747-1.244 1.09-.28.217-.56.404-.871.56a4 4 0 0 1-2.054.56c-1.307-.031-1.774-.778-1.774-1.463 0-.342.125-.716.374-.964.31-.343.778-.498 1.4-.498.902 0 1.774.342 2.427.964m-3.205.498c.031.374.467.467.84.467.53 0 1.058-.156 1.494-.405-.467-.31-.996-.497-1.556-.497-.436 0-.622.124-.685.186a.35.35 0 0 0-.093.25"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GetGuruDark);
export { ForwardRef as GetGuruDark };
